// extracted by mini-css-extract-plugin
export default {"gameFrameWrapper":"MobileLaunchGamePopUp_gameFrameWrapper__alqXR","gameFrame":"MobileLaunchGamePopUp_gameFrame__RbeUM"};